import { useLang } from "@/context/LangContext";

export function Logo({ size = 32, showText = true }) {
  const { t } = useLang();
  return (
    <div className="flex items-center gap-3" data-testid="rexx-logo">
      <div className="relative flex items-center justify-center border border-primary/60 inner-glow" style={{ width: size, height: size }}>
        <span className="font-display font-extrabold text-primary neon-text leading-none" style={{ fontSize: size * 0.5 }}>XX</span>
        <span className="absolute -bottom-[3px] left-0 h-[2px] w-full bg-primary neon-glow" />
      </div>
      {showText && (
        <div className="leading-none">
          <div className="font-display font-bold text-sm tracking-tight text-foreground">{t("common.brand")}</div>
          <div className="font-mono text-[10px] text-primary/70 uppercase tracking-[0.25em]">{t("common.network")}</div>
        </div>
      )}
    </div>
  );
}
